import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import 'moment/locale/id'

class HeaderClock extends Component {
	constructor(props){
		super(props)
		this.state = {
			date: new Date()
		}
	}

	componentDidMount(){
		this.timer = setInterval(
			() => this.tick(),
			1000
		)
	}

	componentWillUnmount(){
		clearInterval(this.timer)
	}

	tick(){
		this.setState({
			date: new Date()
		})
	}

	render(){
		return(
			<div style={{display: 'flex', fontSize: '18px', color: '#FFF'}}>
				{moment(this.state.date).locale('id').format('LLLL')}
			</div>
		)
	}
}

export default HeaderClock


// WEBPACK FOOTER //
// ./src/containers/Widgets/HeaderClock.jsx